<template>
    <project-step-container
            prev-to="rapid_experiments_with_customers_18"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject(redirection)"
    >
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0">
                 {{getMessage(19 , 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <textarea id="first-thing" type="text" v-model="form.next"
                :placeholder="getMessage(19, 'rapidexperiment-sub-placeholder')"
                          rows="3"></textarea>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import {Steps} from '../Utils'
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    export default {
        name: "RapidExperimentsWithCustomers19",
        components: {ProjectStepContainer},
        data() {
            return {
                step: Steps.FORM_NEXT,
                urlNextProject:'finish_20',
                form: {
                    next: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection() {
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

